import React from "react";

function Heading(){
    return(
        <div className="container">
            <h1>Welcome!</h1>
            <p>Hey! My name is Nezam Seraj and I am an aspiring Web Developer/Designer.If you like the work seen in my portfolio and want to collaborate please feel free to reach out on socials. For any potential employers, I have included my email if you would like to reach out. Hope you enjoy my work!</p>
        </div>
    )
}

export default Heading;